export default "__VITE_ASSET__C77t3cZW__"